export enum VirksomhetType {
  LEVERANDOER = 'LEVERANDOER',
  OPPDRAGSGIVER = 'OPPDRAGSGIVER'
}
